export default "__VITE_ASSET__3164d46b__"